export const entities = state => state.data.entities;
